import { TAvatar } from "@common";
import { IAvatarSettings } from "@shared";
import { AvatarPrompts, Gender, Names, Scene, VoiceTypes, Character, Avatar, AvatarsGenderId, IAvatarGender, VoiceItemTypes } from "./types";

export const copyToClipboard = async (link: string): Promise<void> => {    
    try {
        await navigator.clipboard.writeText(link);
    } catch (error) {
        console.error("Failed to copy avatar link: ", error);
    }
};

export const getAvatarDefaultPrompt = (gender: Gender, name: Names, avatarPrompts: AvatarPrompts): string => {
  if (avatarPrompts[gender]) {
    return avatarPrompts[gender](name);
  }

  return avatarPrompts['male']("Андрей");
};

export const removeNewlines = (str: string): string => {
  return str.replace(/\n\n/g, '\n');
};

export const formatCharactersToAvatars = (characters: Character[]): Avatar[] => {
return characters.map((el) => ({
  value: el.id,
  description: el.name,
  url: el.thumbnails?.[0]?.path,
}));
};

export const enrichAvatarsWithGender = (avatarsList: Avatar[], avatarsGender: AvatarsGenderId[], DEFAULT_GENDER: Gender): IAvatarGender[] => {
return avatarsList
  .filter((el) => avatarsGender.some((item) => item.id === el.value))
  .map((el) => {
    const found = avatarsGender.find((item) => item.id === el.value);
    return {
      ...el,
      gender: found?.gender || DEFAULT_GENDER,
      avatarRuName: found?.name || "",
    };
});
};

export const createPlayerSettings = (formData: TAvatar, brainId: string): IAvatarSettings => {
  const result = {
    initialChatEngine: brainId,
    initialTtsEngine: "elevenlabs_regular",
    initialVoiceId: formData.voice,
    initialCamera: { id: "metahumans/visper" },
    initialCharacter: { id: formData.type, title: formData.name, icon: "" },
    initialScene: { id: formData.scene, title: formData.scene },
    initialCharacterPrompt: "",
    logo: "",
    language: formData.language,
    greeting: formData.greeting,
}
  return result;
}